import { PoolType } from "../types";
import { StableLiquidityPool } from "./stable";
class StableLiquidityMetaPool extends StableLiquidityPool {
    constructor(lpToken, metaPooledCurrencies, pooledCurrencies, rewardAmountsYearly, tradingFee, poolId, amplificationCoefficient, totalSupply, isEmpty, basePool // Contains base pool object.
    ) {
        super(PoolType.STABLE_META, lpToken, metaPooledCurrencies, pooledCurrencies, rewardAmountsYearly, tradingFee, poolId, amplificationCoefficient, totalSupply, isEmpty);
        this.basePool = basePool;
    }
}
export { StableLiquidityMetaPool };
//# sourceMappingURL=stable-meta.js.map